mutation CancelContract($id: ID!) {
  cancelContract(id: $id) {
    id
    status
    canceledAt
  }
}
